import { ControllerStatus, GnssStatus, GsmStatus, AccelerometerStatus, StorageStatus } from "../models"


class VehicleStorageStatus extends StorageStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		super(jsonData);

		this.backup = new VehicleBackupStatus(jsonData.backup);
	}

}

class VehicleBackupStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.accelerometer = jsonData.accelerometer;
		this.status = jsonData.status;
	}

}

class VehicleStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.eboardId = jsonData.eboardId;
		this.controllerStatus = new ControllerStatus(jsonData.controllerStatus);
		this.gsmStatus = new GsmStatus(jsonData.gsmStatus);
		this.gnssStatus = new GnssStatus(jsonData.gnssStatus);
		this.accelerometerStatus = new AccelerometerStatus(jsonData.accelerometerStatus);
		this.vehicleStorageStatus = new VehicleStorageStatus(jsonData.vehicleStorageStatus);
		this.lastFixGnssStatus = new GnssStatus(jsonData.lastFixGnssStatus);

	}

	getState() {

		if (!this.controllerStatus)
			return -1;

		let now = Date.now()

		let offlineTreshold = this.controllerStatus.state === 1 ? 60000 : 600000;

		let minInterval = offlineTreshold + 1;

		let intervals = [];
		intervals.push(now - this.controllerStatus.time);
		intervals.push(now - this.gsmStatus.time);
		intervals.push(now - this.gnssStatus.time);
		intervals.push(now - this.accelerometerStatus.time);
		intervals.push(now - this.vehicleStorageStatus.time);

		minInterval = Math.min(...intervals);

		if (minInterval < offlineTreshold)
			return this.controllerStatus.state;
		else
			return -1;
	}

}


export { VehicleStorageStatus, VehicleStatus };